export default [
  {
    "title": "第一部分名称",
    "desc": "短描述",
    "children": [
      {
        "title": "第一章名称",
        "desc": "短描述",
        "children": [
          {
            "title": "三级类目1",
            "desc": "短描述",
          },
          {
            "title": "三级类目2",
            "desc": "短描述",
          }
        ]
      },
      {
        "title": "第二章名称",
        "desc": "短描述",
      }
    ]
  },
  {
    "title": "第二部分名称",
    "desc": "短描述",
    "children": [
      {
        "title": "第三章名称",
        "desc": "短描述",
        "children": [
          {
            "title": "三级类目1",
            "desc": "短描述",
          },
          {
            "title": "三级类目2",
            "desc": "短描述",
          }
        ]
      },
      {
        "title": "第四章名称",
        "desc": "短描述",
      }
    ]
  }
]